module.exports = __webpack_public_path__ + "img/wanwu_banner.ad976e64.png";